<script lang="ts">
	import { Card } from "@hitit/new_ui/src";
	import { formatKrwNumber } from "@hitit/hub/src/v7/utils";
	import { t } from "../../../stores";

	type TotalRevenueRef = {
		count: number;
		amount: number;
		discount: number;
	};

	export let revenueRef: TotalRevenueRef = {
		count: 0,
		amount: 0,
		discount: 0,
	};
	export let loading = false;

</script>

<Card loading={loading}>
	<div class="container">
		{#if loading}
			<span class="card-name">{$t('hub.revenue.revenue_total')} </span>
		{:else}
			<span class="card-name">{$t('hub.revenue.revenue_total')}
				({revenueRef.count}{$t('global.count_2')})</span>
			<h2>{formatKrwNumber(revenueRef.amount)}{$t('global.KRW')}</h2>
			<div class="name-value">
				<span class="name">{$t('global.discount')}</span>
				<span class="value">-
					{formatKrwNumber(revenueRef.discount)}{$t('global.KRW')}</span>
			</div>
		{/if}
	</div>
</Card>

<style lang="scss">
	@import "../../../variables.scss";

	.container {
		display: flex;
		flex-direction: column;
		gap: 10px;
		width: 100%;
		min-height: 170px;
		background: url("/img/common/totalAmount.png") no-repeat right bottom;
		word-break: break-all;
		.card-name {
			color: var(--default-disabled-btn-2);
		}

		h2 {
			color: #3c68d6;
			font-size: 2.125rem;
			font-weight: 600;
			word-break: break-all;
		}
		.name-value {
			display: flex;
			gap: 10px;
			font-size: 1.25rem;
			font-weight: 500;

			.name {
				color: #6d6f76;
			}
			.value {
				color: #e54848;
			}
		}
	}

	@include DesktopSize {
		.container {
			.card-name {
				font-size: 1.25rem;
			}

			h2 {
				font-size: 2.5rem;
			}

			.name-value {
				font-size: 1.5rem;
			}
		}
	}

</style>
